module.exports = "<div class=\"gestio-detail-section\" fxFlex>\n    <ng-content></ng-content>\n</div>\n"